module.exports = __webpack_public_path__ + "static/media/ic_tab_live_selected.036e3585.png";